import React, {FC} from 'react';

interface Props {
}

const Policy: FC<Props> = () => {
  return (
    <main className='terms-page'>
      <div className="container">
        <div className="docs_wrap container">
          <h2>Privacy Policy</h2>
          <div className="docs_updated">
            <span>Effective as of June 01, 2022. Last updated June 01, 2022.</span>
          </div>
          <div className="docs_content">
            <p>
              This Privacy Policy describes the privacy practices of Attitune Lab in connection with the Attitune Lab
              mobile
              application (the “App”) and Attitune Lab website (the “Site”).
            </p>
            <h5>Welcome to Attitune Lab’s Privacy Policy!</h5>
            <p>If you decide not to read this entire Privacy Policy, we want you to walk away with a few key points
              about
              Attitune Lab’s privacy practices:</p>
            <ul>
              <li>The App is a photo analyzer that allows users to check compatibility of emotional portraits based on
                neural network technology We use third-party cloud providers – specifically, Microsoft Azure – to
                process.
              </li>
              <li>We use third-party cloud providers – specifically, Microsoft Azure – to process and edit photographs.
              </li>
              <li>The App only uploads to the cloud the photographs that you specifically select for processing.
              </li>
              <li>Photographs are stored on the cloud servers during the lifetime of your account.
              </li>
              <li>
                <p>We do not use the photographs you provide when you use the App for any
                  reason other than to provide you with emotional compatibility and find the best candidates for
                  friendship,
                  relationships, and creativity.
                </p>
                <p>Please note that Apps’ face detection algorithms are not able to identify a specific person and,
                  therefore, generally cannot be considered as collecting biometric information. HOWEVER, IN CASE THE
                  APPLICABLE LAW STIPULATES THAT IMAGES CAPTURED BY THE CAMERA OR FACE GEOMETRY GENERATED BY APPS ARE
                  CONSIDERED AS BIOMETRIC IDENTIFIERS, BIOMETRIC INFORMATION OR SIMILAR LEGAL CATEGORY, HEREBY YOU
                  EXPRESS
                  YOUR INFORMED WRITTEN CONSENT ON THEIR PROCESSING, AS DESCRIBED IN THIS POLICY.</p>
                <p>If you have any questions about our privacy practices, please email <a
                  href="mailto:info@attitune.us">info@attitune.us</a>.
                </p>
              </li>
            </ul>
            <h4>Personal Information We Collect</h4>
            <p>When you use the App, we may collect information about you, including:</p>
            <ul>
              <li>
                <b>Registration information:</b>
                <ul className="list-style_-">
                  <li>Name;</li>
                  <li>Username;</li>
                  <li>Email address;</li>
                  <li>Mobile number;</li>
                  <li>Gender identity;</li>
                  <li>Date of birth;</li>
                  <li>Photographs;</li>
                  <li>Location;</li>
                  <li>Login information for other accounts that you connect to your Attitune Account (this could
                    include,
                    for example, your Apple ID accounts, Google or instagram account).
                  </li>
                </ul>
              </li>
            </ul>
            <p>For Errors who are California residents, the data we may collect falls within the following categories of
              “personal information”, as defined by the California Consumer Privacy Act (CCPA):</p>
            <ul className="list-style_ABC">
              <li>Identifiers, such as name and location;</li>
              <li>Personal information, as defined in the California customer records law, such as contact (including
                email
                and telephone number) and financial information;
              </li>
              <li>Characteristics of protected classifications under California or federal law (if you choose to provide
                them), such as age, gender identity.
              </li>
              <li>Commercial information, such as transaction information and purchase history;</li>
              <li>Internet or network activity information, such as browsing history and interactions with our Sites and
                App;
              </li>
              <li>Geolocation data, such as mobile device location;</li>
              <li>Visual and similar information, such as photos;</li>
              <li>Inferences drawn from any of the personal information listed above to create a profile or summary
                about,
                for example, an individual’s preferences and characteristics.
              </li>
            </ul>
            <br/>
            <ul>
              <li><b>Photographs you provide when you use the App</b>, via your camera or camera roll (if you have
                granted
                us permission to access your camera or camera roll), the in-App internet search functionality, or your
                social media account (if you choose to connect your social media account). We obtain only the specific
                images you chose to modify using the App; we do not collect your photo albums even if you grant us your
                access to them.
              </li>
              <li><b>App usage information</b>, such as information about how you use the App and interact with us,
                including your preferred language, the date and time when you first installed the App and the date and
                time
                you last used the App.
              </li>
              <li><b>Purchase history</b>, if you choose to purchase an App subscription, such as confirmation that you
                are
                a paid subscriber to the App.
              </li>
              <li><b>Social media information</b>, if you choose to login to the App via a third-party platform or
                social
                media network (for example, Facebook), or otherwise connect your account on the third-party platform or
                network to the App. We may collect information from that platform or network, such as your social media
                alias, first and last name, number of “friends” on the social media platform and, if depending on your
                Facebook or other network settings, a list of your friends or connections (though we do not use or store
                this information). Our collection and processing of the information we obtain from social media
                platforms
                is
                governed by the requirements these social media platforms impose on us in their relevant terms and
                conditions.
              </li>
              <li><b>Device data</b>, such as your computer and mobile device operating system type and version number,
                manufacturer and model, device ID, push tokens, Google Advertising ID, Apple ID for Advertising, browser
                type, screen resolution, IP address (and the associated country in which you are located), the website
                you
                visited before visiting our Site; and other information about the device you are using to visit the App.
              </li>
              <li><b>Online activity data</b>, such as information about your use of and actions on the App and the
                Sites,
                including pages or screens you viewed, how long you spent on a page or screen, navigation paths between
                pages or screens, information about your activity on a page or screen, access times, and length of
                access.
                Our service providers and certain third parties (e.g., online advertising networks and their clients)
                also
                may collect this type of information over time and across third- party websites and mobile applications.
                This information may be collected on our Site using cookies, browser web storage (also known as locally
                stored objects, or “LSOs”), web beacons, and similar technologies. We may collect this information
                directly
                or through our use of third-party software development kits (“SDKs”). SDKs may enable third parties to
                collect information directly from our App.
              </li>
            </ul>
            <h4>How We Use Your Personal Information
            </h4>
            <p>We do not use the photographs you provide when you use the App for any reason other than to provide you
              with
              the processing functionality of the App. We may use information other than photographs for the following
              purposes:</p>
            <p><b>To operate and improve the App:</b></p>
            <ul>
              <li>Enable you to use the App’s features;
              </li>
              <li>Establish and maintain your account, if you choose to login to the App using
                your gmail account;
              </li>
              <li>Communicate with you about the App, including by sending you
                announcements, updates, and security alerts, which we may send through a
                push notification, and responding to your requests, questions and feedback;
              </li>
              <li>Provide technical support and maintenance for the App; and
              </li>
              <li>Perform statistical analysis about use of the App (including and not limited through the use of Google
                Errors).
                To send you marketing and promotional communications. We may send you marketing communications as
                permitted
                by law. You will have the ability to opt-out of our marketing and promotional communications as
                described
                in
                the opt-out of marketing section below.
                To display advertisements to you. If you use the free version of the App, we work with advertising
                partners
                to display advertisements within the App. These advertisements are delivered by our advertising partners
                and
                may be targeted based on your use of the App or your activity elsewhere online. To learn more about your
                choices in connection with advertisements, please see the section below titled “Targeted online
                advertising.”
                For compliance, fraud prevention, and safety. We may use your personal information and disclose it to
                law
                enforcement, government authorities, and private parties as we believe necessary or Appropriate to: (a)
                protect our, your or others’ rights, privacy, safety or property (including by making and defending
                legal
                claims); (b) enforce the terms and conditions that govern the Service; and (c) protect, investigate and
                deter against fraudulent, harmful, unauthorized, unethical or illegal activity.
                With your consent. In some cases, we may specifically ask for your consent to collect, use or share your
                personal information, such as when required by law.
              </li>
              <li></li>
            </ul>
            <p><b>To send you marketing and promotional communications.</b> We may send you marketing communications as
              permitted by law. You will have the ability to opt-out of our marketing and promotional communications as
              described in the opt-out of marketing section below.</p>
            <p><b>To display advertisements to you.</b> If you use the free version of the App, we work with advertising
              partners to display advertisements within the App. These advertisements are delivered by our advertising
              partners and may be targeted based on your use of the App or your activity elsewhere online. To learn more
              about your choices in connection with advertisements, please see the section below titled “Targeted online
              advertising.”</p>
            <p><b>For compliance, fraud prevention, and safety.</b> We may use your personal information and disclose it
              to
              law enforcement, government authorities, and private parties as we believe necessary or Appropriate to:
              (a)
              protect our, your or others’ rights, privacy, safety or property (including by making and defending legal
              claims); (b) enforce the terms and conditions that govern the Service; and (c) protect, investigate and
              deter
              against fraudulent, harmful, unauthorized, unethical or illegal activity.</p>
            <p><b>With your consent.</b> In some cases, we may specifically ask for your consent to collect, use or
              share
              your personal information, such as when required by law.</p>
            <p><b>To create anonymous, aggregated or de-identified data.</b> We may create anonymous, aggregated or
              de-identified data from your personal information and other individuals whose personal information we
              collect.
              We make personal information into anonymous, aggregated or de-identified data by removing information that
              makes the data personally identifiable to you. We may use this anonymous, aggregated or de- identified
              data
              and share it with third parties for our lawful business purposes.</p>
            <h4>How We Share Your Personal Information</h4>
            <p>We do not disclose user photos or videos to third parties (with the exception of our employees who
              perform
              operational services for moderation, protection, and other actions and to the other Attitune users for in
              app
              interaction). We may share your non-photograph and non-video information in the following
              circumstances:</p>
            <p><b>Affiliates.</b> We may share app usage information with our subsidiaries and affiliates, for purposes
              consistent with this Privacy Policy.</p>
            <p><b>Service providers.</b> We may share your personal information with services providers that perform
              services on our behalf or help us operate the App (such as customer support, hosting, analytics, email
              delivery, marketing, and database management services). These third parties may use your personal
              information
              only as directed or authorized by us and in a manner consistent with this Privacy Policy, and are
              prohibited
              from using or disclosing your information for any other purpose.</p>
            <p><b>Advertising partners.</b> When we use third-party cookies and other tracking tools, our advertising
              partners may collect information from your device to help us analyze use of the Site and the App, display
              advertisements on the App and advertise the Site and App (and related content) elsewhere online.</p>
            <p><b>Third-party platforms and social media networks.</b> If you have enabled features or functionality
              that
              connect the App to a third-party platform or social media network (such as by logging into Attitune Lab
              using
              your account with the third-party, providing your API key or similar access token for the App to a
              third-party, or otherwise linking your account with the App to a third-party’s services), we may disclose
              the
              personal information that you authorized us to share (such as when you elect to upload a photograph or
              video
              to your social media account). We do not control the third-party platforms’ use of your personal
              information,
              which is governed by that third party’s privacy policy and terms and conditions.</p>
            <p><b>Professional advisors.</b> We may disclose your personal information to professional advisors, such as
              lawyers, bankers, auditors and insurers, where necessary in the course of the professional services that
              they
              render to us.</p>
            <p><b>For compliance, fraud prevention and safety.</b> We may share your personal information for the
              compliance, fraud prevention and safety purposes described above.</p>
            <p><b>Business transfers.</b> We may sell, transfer or otherwise share some or all of our business or
              assets,
              including your personal information, in connection with a business transaction (or potential business
              transaction) such as a corporate divestiture, merger, consolidation, acquisition, reorganization or sale
              of
              assets, or in the event of bankruptcy or dissolution.</p>
            <h4>Compliance with Law</h4>
            <p>We may be required to use and share your personal information to comply with applicable laws, lawful
              requests, and legal process, such as to respond to subpoenas or requests from government authorities.
            </p>
            <h4>Your Choices</h4>
            <p>In this section, we describe the rights and choices available to all users.</p>
            <p><b>Opt out of marketing communications and other push notifications.</b> You may opt out of
              marketing-related
              communications and other notifications we may send you via push notification by changing the settings on
              your
              mobile device.</p>
            <p><b>Device permissions.</b> You may revoke any permissions you previously granted to us, such as
              permission
              to
              access your camera, camera roll, or microphone through the settings on your mobile device.</p>
            <p><b>Cloud processing.</b> You may request that we remove your information, including photographs from the
              cloud.</p>
            <p><b>Cookies & Browser Web Storage.</b> Most browsers let you remove or reject cookies. To do this, follow
              the
              instructions in your browser settings. Many browsers accept cookies by default until you change your
              settings.
              Please note that if you set your browser to disable cookies, the Site may not work properly. Similarly,
              your
              browser settings may allow you to clear your browser web storage.</p>
            <p><b>Targeted online advertising.</b> Some of the business partners that collect information about users’
              activities on or through the Site or App may be members of organizations or programs that provide choices
              to
              individuals regarding the use of their browsing behavior or mobile application usage for purposes of
              targeted
              advertising.
            </p>
            <p>Site users may opt out of receiving targeted advertising on websites through members of the Network
              Advertising Initiative or the Digital Advertising Alliance. App users may opt out of receiving targeted
              advertising in mobile apps through participating members of the Digital Advertising Alliance by installing
              the
              AppChoices mobile app, and selecting the user’s choices. Please note that we also may work with companies
              that
              offer their own opt-out mechanisms and may not participate in the opt-out mechanisms that we linked above.
            </p>
            <p>In addition, your mobile device settings may provide the functionality to limit our, or our partners’,
              ability to engage in ad tracking or targeted advertising using the Google Advertising ID or Apple ID for
              Advertising associated with your mobile device.
            </p>
            <p>If you choose to opt-out of targeted advertisements, you will still see advertisements online but they
              may
              not be relevant to you. Even if you do choose to opt out, not all companies that serve online behavioral
              advertising are included in this list, so you may still receive some cookies and tailored advertisements
              from
              companies that are not listed.
            </p>
            <p><b>Choosing not to share your personal information.</b> Where we are required by law to collect your
              personal
              information, or where we need your personal information in order to provide the App to you, if you do not
              provide this information when requested (or you later ask to delete it), we may not be able to provide you
              with our services. We will tell you what information you must provide to use the App by designating it as
              required at the time of collection or through other appropriate means.
            </p>
            <p><b>Third-party platforms or social media networks.</b> If you choose to connect to the App via a
              third-party
              platform or social media network, such as by using Gmail login, you may have the ability to limit the
              information that we may obtain from the third-party at the time you login to the App using the
              third-party’s
              authentication service or otherwise connect your account. Subsequently, you may be able to control your
              settings through the third-party’s platform or service. For example, you may access and change your
              settings
              through the Gmail settings page for Apps and Websites. If you withdraw our ability to access certain
              information from a third-party platform or social media network, that choice will not apply to information
              that we have already received from that third party.
            </p>
            <h4>Other Sites, Mobile Applications and Services
            </h4>
            <p>The App may contain links to other websites, mobile applications, and other online services operated by
              third
              parties. These links are not an endorsement of, or representation that we are affiliated with, any third
              party. In addition, our content may be included on web pages or in mobile applications or online services
              that
              are not associated with us. We do not control third party websites, mobile applications or online
              services,
              and we are not responsible for their actions. Other websites, mobile applications and online services
              follow
              different rules regarding the collection, use and sharing of your personal information. We encourage you
              to
              read the privacy policies of the other websites, mobile applications and online services you use.
            </p>
            <h4>Security Practices
            </h4>
            <p>We use commercially reasonable security practices to help keep the information collected through the App
              secure and take reasonable steps to verify your identity before granting you access to your account (if
              you
              have an account with us). However, Attitune Lab cannot ensure the security of any information you transmit
              to
              Attitune Lab or guarantee that information on the App may not be accessed, disclosed, altered, or
              destroyed.
            </p>
            <p>Please do your part to help us. You are responsible for maintaining the confidentiality of your login
              information and device identifiers, and for controlling access to communications between you and Attitune
              Lab,
              at all times. Your privacy settings may also be affected by changes the social media services you connect
              to
              Attitune Lab make to their services. We are not responsible for the functionality, privacy, or security
              measures of any other organization.
            </p>
            <h4>Children
            </h4>
            <p>The App is not directed at children under the age of 18, and our <a href="/terms">Terms of Use</a> do not
              allow children under 18
              years of age to use the App. If we learn that we have collected personal information of a child under the
              age
              of 18, we will delete it. We encourage parents with concerns to contact us.
            </p>
            <h4>Changes to the Privacy Policy
            </h4>
            <p>We reserve the right to modify this Privacy Policy at any time. If we make material changes to this
              Privacy
              Policy, we will notify you by updating the date of this Privacy Policy and posting it on the App. We may,
              and
              if required by law, will provide notification of changes in another way that we believe is reasonably
              likely
              to reach you, such as through the App.
            </p>
            <p>Any modifications to this Privacy Policy will be effective upon our posting of the new terms and/or upon
              implementation of the new changes on the App (or as otherwise indicated at the time of posting). In all
              cases,
              your continued use of the App after the posting of any modified Privacy Policy indicates your acceptance
              of
              the terms of the modified Privacy Policy.
            </p>
            <h4>How to Contact Us
            </h4>
            <p>Please direct any questions or comments about this Policy or privacy practices to <a
              href="mailto:info@attitune.us">info@attitune.us</a>.You may also write to us via postal mail at: 2501 S
              Ocean drive apt 624 Hollywood Florida 33019.
            </p>
            <p><b>Legal bases for processing.</b> We use your personal information only as permitted by law. Our legal
              bases
              for processing the personal information described in this Privacy Policy are described in the table below.
            </p>
            <table className="table table-bordered">
              <thead>
              <tr>
                <th className='w-50'>
                  <div>Processing purpose</div>
                  <p className="font-italic font-weight-light">Details regarding each processing purpose listed below
                    are
                    provided in the section above titled “How we use your personal information”.</p>
                </th>
                <th className='w-50'>
                  Legal basis
                </th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>To operate and improve the App
                </td>
                <td>Processing is necessary to perform the contract governing our provision of services in connection
                  with
                  the App, or to take steps that you request prior to signing up for the App. If we have not entered
                  into
                  a
                  contract with you, we process your personal information based on our legitimate interest in providing
                  the
                  services you access and request in connection with the App.
                </td>
              </tr>
              <tr>
                <td className="px-0">
                  <div className="px-2 mx-1">To send you marketing and promotional communications</div>
                  <hr/>
                  <div className="px-2 mx-1">
                    <div>To display advertisements to you</div>
                    <div className="py-2">For compliance, fraud prevention and safety</div>
                    <div>To create anonymous, aggregated or de-identified data</div>
                  </div>
                </td>
                <td>These activities constitute our legitimate interests. We do not use your personal information for
                  these
                  activities where our interests are overridden by the impact on you (unless we have your consent or are
                  otherwise required or permitted to by law).
                </td>
              </tr>
              <tr>
                <td>Compliance with Law</td>
                <td>Processing is necessary to comply with our legal obligations.</td>
              </tr>
              <tr>
                <td>With your consent</td>
                <td>Processing is based on your consent. Where we rely on your consent you have the right to withdraw it
                  any
                  time in the manner indicated when you consent or in the App.
                </td>
              </tr>
              </tbody>
            </table>
            <div><b>Your rights</b></div>
            <p>European data protection laws give you certain rights regarding your personal information. If you are
              located
              within the European Union, you may ask us to take the following actions in relation to your personal
              information that we hold:</p>
            <ul>
              <li><b>Access.</b> Provide you with information about our processing of your personal information and give
                you
                access to your personal information.
              </li>
              <li><b>Correct.</b> Update or correct inaccuracies in your personal information.
              </li>
              <li><b>Delete.</b> Delete your personal information.
              </li>
              <li><b>Transfer.</b> Transfer a machine-readable copy of your personal information to you or a third party
                of
                your choice.
              </li>
              <li><b>Restrict.</b> Restrict the processing of your personal information.
              </li>
              <li><b>Object.</b> Object to our reliance on our legitimate interests as the basis of our
                processing of your personal information that impacts your rights.
              </li>
            </ul>
            <p>You may submit these requests by email to or our postal address provided above.
            </p>
            <p>If you would like to submit a complaint about our use of your personal information or our response to
              your
              requests regarding your personal information, you may contact us or submit a complaint to the data
              protection
              regulator in your jurisdiction.
            </p>
            <h4>Notice to California Residents
            </h4>
            <p>We are required by the California Consumer Privacy Act of 2018 (“CCPA”) to provide to California
              residents
              an
              explanation of how we collect, use and share their personal information, and of the rights and choices, we
              offer California residents regarding our handling of their personal information.
            </p>
            <p>We do not sell personal information. As we explain in this Privacy Policy, we use cookies and other
              tracking
              technologies to analyze Site and App traffic and use and facilitate advertising. If you would like to opt
              out
              of our (and our third-party advertising partners’) use of cookies and other tracking technologies, please
              review the instructions provided in the Online Tracking Opt-out Guide.
            </p>
            <p>In addition to disclosures of personal information to our service providers and professional advisors,
              for
              compliance, fraud prevention and safety, and in connection with a business transfer, as described in the
              “How
              We Share Your Personal Information” section of the Privacy Policy, the following chart further describes
              our
              privacy practices with respect to the personal information of our California consumers.
            </p>
            <table className="table table-bordered">
              <thead>
              <tr>
                <th style={{width: '20%'}}>Personal information we collect</th>
                <th style={{width: '20%'}}>CCPA-defined categories</th>
                <th style={{width: '20%'}}>Sources of personal information</th>
                <th style={{width: '20%'}}>Purposes for which we may collect and use the personal information</th>
                <th style={{width: '20%'}}>Data Sharing</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>Photographs</td>
                <td>Physical description
                </td>
                <td>You</td>
                <td>To operate and improve the App</td>
                <td>
                  <p>Shared with third-party platforms (e.g., social media networks) at your direction</p>
                  <p>Shared with cloud service providers (i.e., Google Cloud Platform and Microsoft Azure)</p>
                </td>
              </tr>
              <tr>
                <td>App usage information</td>
                <td>
                  <p>Online identifiers</p>
                  <p>Internet or network information
                  </p>
                  <p> Inferences</p>
                </td>
                <td>
                  <p>You</p>
                  <p>Automatic collection</p>
                </td>
                <td>
                  <p>To operate and improve the App</p>
                  <p>To send you marketing and promotional communications</p>
                </td>
                <td>Shared with affiliates that provide services to us
                </td>
              </tr>
              <tr>
                <td>Purchase Attitune Lab
                </td>
                <td>
                  <p>Commercial information
                  </p>
                  <p>Online identifiers
                  </p>
                </td>
                <td>The app store provider through which you purchased your subscription (i.e., Apple)
                </td>
                <td>To operate and improve the App
                </td>
                <td>None</td>
              </tr>
              <tr>
                <td>Social media information
                </td>
                <td>Identifiers Online identifiers
                </td>
                <td>Third-party platforms
                </td>
                <td>To operate and improve the App
                </td>
                <td>Shared with third-party platforms (e.g., social media networks) at your direction
                </td>
              </tr>
              <tr>
                <td>
                  <p>Device data
                  </p>
                  <p>Online activity data
                  </p>
                </td>
                <td>
                  <p>Online identifiers
                  </p>
                  <p>Internet or network information
                  </p>
                  <p>Inferences
                  </p>
                </td>
                <td>
                  <p>You</p>
                  <p>Automatic collection
                  </p>
                </td>
                <td>To display advertisements to you
                </td>
                <td>Collected directly by advertising partners
                </td>
              </tr>
              </tbody>
            </table>
            <h4>California Residents’ Privacy Rights
            </h4>
            <p>Except as excluded from the scope of this notice above, the CCPA grants California residents the
              following
              rights.
            </p>
            <ul>
              <li><b>Information.</b> You can request information about how we have collected, used and shared and used
                your
                personal information during the past 12 months.
              </li>
              <li><b>Access.</b> You can request a copy of the personal information that we maintain about you.
              </li>
              <li>
                <div><b>Deletion.</b> You can ask us to delete the personal information that we collected or maintain
                  about
                  you.
                </div>
                <div>Please note that the CCPA limits these rights by, for example, prohibiting us from providing
                  certain
                  sensitive information in response to an access request and limiting the circumstances in which we must
                  comply with a deletion request. If we deny your request, we will communicate our decision to you.
                  You are entitled to exercise the rights described above free from discrimination.
                </div>
                <h4>How to Submit a Request</h4>
                <div>To request access to or deletion of personal information: email <a
                  href="mailto:info@attitune.us">info@attitune.us</a>.
                </div>
              </li>
            </ul>
            <p><b>Identity verification.</b> The CCPA requires us to verify the identity of the individual submitting a
              request to access or delete personal information before providing a substantive response to the request.
              We
              may attempt to verify your identity by asking you to confirm information that we have on file about you or
              your interactions with us. Where we ask for additional personal information to verify your identity, we
              will
              only use it to verify your identity or your authority to make the request on behalf of another consumer.
            </p>
            <p><b>Authorized agents.</b> California residents can empower an “authorized agent” to submit requests on
              their
              behalf. We will require the authorized agent to have written authorization confirming such authority.
            </p>
            <h3>CCPA Glossary
            </h3>
            <div className="mb-2"><b>Statutory Category
            </b></div>
            <div className="mb-2"><b>Commercial Information
            </b></div>
            <div className="mb-2"><b>Identifiers
            </b></div>
            <div className="mb-2"><b>Inferences</b></div>
            <div className="mb-2"><b>Internet or Network Information
            </b></div>
            <div><b>Online Identifiers
            </b></div>
            <h5>Data Elements within the Category
            </h5>
            <p>Records of personal property, products or services purchased, obtained, or considered, or other
              purchasing
              or
              consuming histories or tendencies.
            </p>
            <p>Real name, alias, postal address, unique personal identifier, customer number, email address, account
              name,
              social security number, driver’s license number, passport number, or other similar identifiers.
            </p>
            <p>The derivation of information, data, assumptions, or conclusions from any other category of Personal
              Information to create a profile about a person reflecting the person's preferences, characteristics,
              psychological trends, predispositions, behavior, attitudes, intelligence, abilities and aptitudes.
            </p>
            <p>Browsing history, search history, and information regarding a person’s interaction with an Internet
              website,
              application, or advertisement.
            </p>
            <p>An online identifier or other persistent identifier that can be used to recognize a person, family or
              device,
              over time and across different services, including but not limited to, a device identifier; an Internet
              Protocol address; cookies, beacons, pixel tags, mobile ad identifiers, or similar technology; customer
              number,
              unique pseudonym, or user alias; telephone numbers, or other forms of persistent or probabilistic
              identifiers
              (i.e., the identification of a person or a device to a degree of certainty of more probable than not) that
              can
              be used to identify a particular person or device.
            </p>
            <p>An individual’s physical characteristics or description (e.g., hair color, eye color, height, weight).
            </p>
            <h5>Physical Description
            </h5>
            <h3>Online Tracking Opt-Out Guide
            </h3>
            <p>Like many companies online, we may use services provided by Google, Facebook, Twitter and other companies
              that use tracking technology. These services rely on tracking technologies – such as cookies and web
              beacons
              –
              to collect directly from your device information about your browsing activities, your interactions with
              websites, and the device you are using to connect to the Internet. There are a number of ways to opt out
              of
              having your online activity and device data collected through these services, which we have summarized
              below:
            </p>
            <ul>
              <li><b>Blocking cookies in your browser.</b> Most browsers let you remove or reject cookies, including
                cookies
                used for interest-based advertising. To do this, follow the instructions in your browser settings. Many
                browsers accept cookies by default until you change your settings. For more information about cookies,
                including how to see what cookies have been set on your device and how to manage and delete them, visit
                <a href="www.allaboutcookies.org" target="_blank">www.allaboutcookies.org</a>.
              </li>
              <li><b>Blocking advertising ID use in your mobile settings.</b> Your mobile device settings may provide
                functionality to limit use of the advertising ID associated with your mobile device for interest-based
                advertising purposes.
              </li>
              <b>Using privacy plug-ins or browsers.</b> You can block our websites from setting cookies used for
              interest-based ads by using a browser with privacy features, like Brave, or installing browser plugins
              like
              Privacy Badger, Ghostery or uBlock Origin, and configuring them to block third party cookies/trackers. You
              can
              also opt-out of Google Errors by downloading and installing the browser plug-in available at:
              <a href="https://tools.google.com/dlpage/gaoptout">https://tools.google.com/dlpage/gaoptout</a>.
              <li><b>Platform opt-outs.</b> The following advertising partners offer opt-out features that let you opt
                out
                of use of your information for interest-based advertising:
              </li>
            </ul>

            <div className="mb-2">Google: <a href="adssettings.google.com" target="_blank">adssettings.google.com</a>
            </div>
            <div className="mb-2">Facebook: <a href="www.facebook.com/about/ads"
                                               target="_blank">www.facebook.com/about/ads</a>
            </div>
            <div className="mb-2">Twitter: <a href="twitter.com/settings/personalization"
                                              target="_blank">twitter.com/settings/personalization</a>
            </div>
            <p><b>• Advertising industry opt-out tools.</b> You can also use these opt-out options to limit use of your
              information for interest-based advertising by participating companies:
            </p>
            <div className="mb-2">Digital Advertising Alliance for Websites: <a href="optout.aboutads.info"
                                                                                target="_blank">optout.aboutads.info</a>
              o Digital Advertising Alliance for Mobile
            </div>
            <div className="mb-2">Apps: <a href="www.youradchoices.com/appchoices"
                                           target="_blank">www.youradchoices.com/appchoices</a>
            </div>
            <div className="mb-2">Network Advertising Initiative: <a href="optout.networkadvertising.org/?c=1"
                                                                     target="_blank">optout.networkadvertising.org/?c=1</a>
            </div>
            <p>Note that because these opt-out mechanisms are specific to the device or browser on which they are
              exercised,
              you will need to opt-out on every browser and device that you use.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Policy;